// extracted by mini-css-extract-plugin
export var button = "button-module--button--X-qXA";
export var icon = "button-module--icon--Gso9o";
export var solid = "button-module--solid--SetP0";
export var outline = "button-module--outline--tKGat";
export var outlineLt = "button-module--outlineLt--XApzx";
export var small = "button-module--small--0OCIw";
export var fadeIn = "button-module--fadeIn--ikSG4";
export var slideIn = "button-module--slideIn--R6bUQ";